// src/services/datasetApi.js
import { http, authedHttp } from './http'
import { apiBase } from '../config/apiConfig'

/** build URLSearchParams where filters are deepObject:
 *  filters[key]=v AND for arrays: filters[key]=a&filters[key]=b
 */
function toSearchParams(params = {}) {
  const sp = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) {
    if (v == null) continue
    if (k !== 'filters') {
      // simple scalar params
      sp.set(k, String(v))
      continue
    }
    // deepObject filters
    const filters = v || {}
    for (const [fk, fv] of Object.entries(filters)) {
      if (fv == null) continue
      const values = Array.isArray(fv) ? fv : [fv]
      for (const val of values) {
        // filters[level1]=Happiness (repeat key for arrays)
        sp.append(`filters[${fk}]`, String(val))
      }
    }
  }
  return sp
}

export async function getFacets({ path_prefix, filters } = {}) {
  const sp = toSearchParams({ path_prefix, filters })
  const url = `${apiBase('/v1/facets')}${sp.toString() ? `?${sp}` : ''}`
  return http.get(url)
}

export async function getFiles({ page = 1, limit = 100, path_prefix, filters } = {}) {
  const sp = toSearchParams({ page, limit, path_prefix, filters })
  const url = `${apiBase('/v1/files')}${sp.toString() ? `?${sp}` : ''}`
  return authedHttp.get(url)
}
